import { ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType } from '../../../api/models/iTopFiveApiV2EndpointsTopFiveGetTopFiveSearchType';

export type PeriodType = 'current' | 'previous';

export const PERIOD_OPTIONS = [
  { text: 'Previous', value: 'previous' },
  { text: 'Current', value: 'current' },
];

export const FILTER_TYPE_OPTIONS = [
  { text: 'Staff', value: '0' },
  { text: 'Top Five', value: '1' },
] as const;

export type FilterType = (typeof FILTER_TYPE_OPTIONS)[number]['value'];

export const FILTER_TO_SEARCH_TYPE_MAP = {
  '0': ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType.Name,
  '1': ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType.TopFive,
} as const;
